<template>
    <titan-form :schema="schema" v-on:saveData="saveData()" :model="dataItem"/>
</template>

<script>
    import TheHeader from '../../../../admin/Layout/TheHeader'
    import TitanForm from '../../../../core/Form/Form'
    import VueFormGenerator from "vue-form-generator";

    export default {
        components: {
            TheHeader,
            TitanForm
        },
        mounted() {
            this.getTypes();
        },
        methods: {
            getTypes() {
                this.$store.dispatch('notifications/supportedTypes').then(data => {
                    const profile = this.$store.state.account.user.userDisabledNotification;

                    data.forEach(key => {
                        const found = profile.find(disabledNotification => {
                            return disabledNotification.type === key;
                        });
                        this.dataItem[key] = found === undefined;
                        this.schema[0].fields.push({
                            type: 'titanSwitch',
                            label: this.t(key),
                            model: key
                        });
                    });
                    this.dataItem = {...this.dataItem};
                });
            },
            saveData() {
                let out = [];
                Object.keys(this.dataItem).forEach(modelKey => {
                    if (this.dataItem[modelKey] === false) {
                        out.push(modelKey);
                    }
                });
                this.$store.dispatch('account/saveNotifications', {disabled: out}).then(res => {
                    this.$store.dispatch('account/get')
                });
            }
        },
        data() {
            return {
                dataItem: {},
                schema: [
                    {
                        name: this.t('E-mail notifications'),
                        type: 'main',
                        fields: []
                    }
                ]
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/private/profile/components/Notifications.vue